import { ReactComponent as ApplePay } from 'assets/icons/ApplePay.svg';
import Icon from 'components/lib/Icon';
import './Icon.scss';

export const ApplePayIcon = () => (
  <Icon id="ApplePay-Icon" icon={ApplePay} viewBox="0 0 52 23" />
);
